export { default as KeyPoints } from "./KeyPointsCards";
export type { KeyPointsProps } from "./KeyPointsCards";
